import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage, ref } from "firebase/storage";

const firebaseApp = initializeApp({
  apiKey: "AIzaSyC5BO29w5vWXt-E3LXSGe6HByVsdRVDjBI",
  authDomain: "arrawoop22.firebaseapp.com",
  projectId: "arrawoop22",
  storageBucket: "arrawoop22.appspot.com",
  messagingSenderId: "1064183727121",
  appId: "1:1064183727121:web:a9714f070cd970924fddb0",
});

export const db = getFirestore(firebaseApp);

export const storage = getStorage(firebaseApp);
export const imageRef = ref(storage);
